import { c as _c } from "react/compiler-runtime";
import type { ConfigInterface, NextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useContext } from 'react';
import { routes } from '../bff/routes';
import type { GetAccountByUuidParams, GetAccountByUuidResponse } from '../bff/types';
import { useGetApiCacheKey } from '../lib/hooks/use-get-api-cache-key';
import { AccountUIApiContext } from '../provider';
export const useGetAccountCacheKey = () => {
  const $ = _c(2);
  const getCacheKey = useGetApiCacheKey();
  let t0;
  if ($[0] !== getCacheKey) {
    t0 = accountUuid => getCacheKey(routes.getAccount.getUrl({
      params: {
        accountUuid
      }
    }));
    $[0] = getCacheKey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getAccountCacheKey = t0;
  return getAccountCacheKey;
};
export function useAccount(params, config) {
  const $ = _c(3);
  const {
    basePath
  } = useContext(AccountUIApiContext);
  let t0;
  if ($[0] !== basePath || $[1] !== params) {
    t0 = routes.getAccount.getUrl({
      params,
      basePath
    });
    $[0] = basePath;
    $[1] = params;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useNextApiSubscription(t0, config);
}